var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"tag":_vm.renderedTag,"element-type":_vm.elementType}},[_vm._t("default",null,{"element":_vm.element,"elementsNew":_vm.elementsNew,"elementUpdated":_vm.elementUpdated})],2)}
var staticRenderFns = []

export { render, staticRenderFns }